import { Component, inject, input } from "@angular/core";
import { DialogAdapter } from "common/dialog/dialog-adapter";
import { NewDialogComponent } from "common/newdialog/dialog.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
	selector: "stages-popup-header",
	templateUrl: "./popup-header.component.html",
	imports: [TranslateModule],
})
export class PopupHeaderComponent {
	private dialog = inject(DialogAdapter);

	readonly viewedDialog = input<NewDialogComponent>();

	close(): void {
		const viewedDialog = this.viewedDialog();
		if (viewedDialog) {
			viewedDialog.close();
		} else {
			this.dialog.close(undefined);
		}
	}
}
